export default {
  get: function (allocations, selectedAllocations) {
    return {
      Id: '_',
      '*Name': {
        label: 'Cost Center',
        width: 120,
        options: allocations,
        source: true,
        compose: allocationName,
        selectedOptions: selectedAllocations,
        trackBy: {
          optionTrackBy: 'Key',
          selectedOptionTrackBy: 'Id'
        },
        editable: true
      },
      AdditionalNo: {
        label: 'Secondary ID',
        width: 90,
        editable: true,
        maxLength: 50
      },
      Percent: {
        label: 'Allocation Percent',
        width: 80,
        editable: true
      },
      Amount: {
        label: 'Allocation Amount',
        width: 80,
        f: 'data.Amount',
        validSum: {value: 0},
        editable: true
      }
    }
  }
}
function allocationName(params) {
  return params.data && params.data.Name ? params.data.Name : ' '
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/cc-allocation-model.js